import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  deleteButton: {
    border: "none !important",
    color: "rgba(0, 0, 0) !important",
    "&:hover": {
      color: "rgba(0, 0, 0) !important",
      backgroundColor: "rgba(0, 0, 0, 0.04) !important",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.26) !important",
    },
    "& svg": {
      color: "inherit !important",
    },
  },
  Badge: {
    padding: "2px 8px",
    borderRadius: "2px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    textAlign: "center",
    width: 75,
    color: `${theme.color.white} !important`,
  },
  TableRowCode: {
    "& > div span": {
      color: theme.color.blue,
    },
    "&.disabled": {
      "& span": {
        color: `${theme.color.gray3} !important`,
      },
    },
  },
  DatePicker: {
    width: "100%",
    maxWidth: 140,
  },
  selectInput: {
    flex: 1,
    border: `1px solid ${theme.color.gray2}`,
    paddingLeft: 10,
    paddingRight: 10,
    "&:before": {
      display: "none",
    },
    "& .MuiInput-input": {
      height: 29,
      fontSize: 15,
      display: "flex",
      alignItems: "center",
    },
  },
  NoResultPlaceHolder: {
    minHeight: "420px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& h3": {
      position: "relative",
      top: "-130px",
    },
  },
  form: {
    flex: 1,
  },
  formTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  formFilter: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  footerForm: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 20,
  },
  fieldsRow: {
    display: "flex",
    flexDirection: "row",
    marginLeft: -15,
    marginRight: -15,
    marginBottom: 10,
  },
  fieldsCol: {
    flex: 1,
    maxWidth: 260,
    paddingLeft: 15,
    paddingRight: 15,
    marginBottom: 4,
  },
  newFormFieldsRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
    marginTop: 20,
  },
  newFormFieldsCol: {
    flex: 1,
    maxWidth: "48%",
  },
  newFormFieldSmallCol: {
    flex: 1,
    maxWidth: "24%",
  },
  paperForm: {
    width: "100%",
    flexDirection: "column",
    marginBottom: 15,
  },
  paperFormHead: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 15px",
    borderBottom: "1px solid #dddddd",
  },
  paperFormTopHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 15px",
    marginTop: 15,
    border: "1px solid #dddddd",
  },
  paperFormBody: {
    padding: 15,
  },
  paperFormBodyTop: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  tdPaddingXs: {
    padding: "8px 4px",
  },
  errorField: {
    minHeight: 20,
    color: theme.color.red,
    fontSize: 12,
  },
  topFormTable: {
    textTransform: "uppercase",
    background: "#F4F5F7 0% 0% no-repeat padding-box",
    borderRadius: "3px 3px 0px 0px",
    "& th": {
      color: "#7A869A",
      lineHeight: "16px",
      fontSize: 13,
    },
    "& th, td": {
      padding: "4px 12px !important",
    },
  },
  bodyFormTable: {
    "& th, td": {
      padding: "4px 12px !important",
      verticalAlign: "top",
      "&:last-child": {
        verticalAlign: "middle",
      },
    },
  },
  ButtonGroup: {
    marginRight: 8,
  },
  ExpandMoreIcon: {
    "&.MuiSvgIcon-root": {
      color: theme.color.white,
    },
  },
  expandButton: {
    borderLeft: "none",
    boxShadow: "none",
    padding: "6px !important",
    minHeight: "37px !important",
    "&:focus": {
      backgroundColor: "#457dd9 !important",
    },
  },
  newButton: {
    borderRight: "none",
    boxShadow: "none",
    padding: "6px !important",
  },
  menuButton: {
    marginRight: ` ${theme.spacing(5)}px !important `,
  },
  BtnOnPopper: {
    width: 250,
    "&.MuiButtonGroup-grouped": {
      padding: 6,
      justifyContent: "flex-start",
      minWidth: 166,
      background: theme.color.white,
      textAlign: "left",
    },
  },
  BtnExpand: {
    "&.MuiButtonGroup-grouped": {
      paddingLeft: 30,
    },
  },
  BtnExport: {
    marginLeft: 20,
  },
  productsTableCellHead: {
    minHeight: 40,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  stepContainer: {
    display: "flex",
    flexDirection: "column",
    padding: 12,
    marginBottom: 24,
  },
}));
